module.exports = __webpack_public_path__ + "img/bg.3ab361ac.webp";